/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_TemplateInputs */

const en_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template`)
};

const es_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantilla`)
};

const fr_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modèle`)
};

const de_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage`)
};

const ja_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テンプレート`)
};

const zh_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模板`)
};

const ar_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قالب`)
};

const id_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templat`)
};

const it_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modello / Template`)
};

const ru_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шаблон`)
};

const pt_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template`)
};

const ko_val_template = /** @type {(inputs: Val_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`템플릿`)
};

/**
* | output |
* | --- |
* | "Template" |
*
* @param {Val_TemplateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_template = /** @type {((inputs?: Val_TemplateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_TemplateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_template(inputs)
	if (locale === "es") return es_val_template(inputs)
	if (locale === "fr") return fr_val_template(inputs)
	if (locale === "de") return de_val_template(inputs)
	if (locale === "ja") return ja_val_template(inputs)
	if (locale === "zh") return zh_val_template(inputs)
	if (locale === "ar") return ar_val_template(inputs)
	if (locale === "id") return id_val_template(inputs)
	if (locale === "it") return it_val_template(inputs)
	if (locale === "ru") return ru_val_template(inputs)
	if (locale === "pt") return pt_val_template(inputs)
	return ko_val_template(inputs)
});